import { useNavigate } from "react-router-dom";
import React, { useCallback } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CustomCard } from '../../components/CustomCard';
import { authBody, authCard, authTitle } from '../../theme';
import styles from './style';

const NotFound = React.memo(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const pageNotAvailableTrad = t('pageNotAvailable');
  const goBackHomeTrad = t('goBackToHome');

  const goBackToHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <>
      <Container maxWidth="sm" sx={styles.container}>
        <CustomCard noPadding sx={authCard}>
          <Box sx={authBody}>
            <Grid container direction="row">
              <Grid item xs={12}>
                <Typography variant="h4" align="center" sx={authTitle}>
                  {pageNotAvailableTrad}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="center"
                mt={4}
              >
                <Button
                  variant="contained"
                  onClick={goBackToHome}
                  color="primary"
                  sx={styles.button}
                >
                  {goBackHomeTrad}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CustomCard>
      </Container>
    </>
  );
});

export default NotFound;
